import { useEffect } from 'react';

import { useLocation } from 'react-router-dom';
import { useMicrofrontendStore } from '../store/useMicroFrontendStore';

export const useModuleLoad = () => {
  const location = useLocation();
  const {
    isLoaded,
    setLoaded,
    reset: resetModulesLoad,
    listeners,
  } = useMicrofrontendStore((state) => state);

  useEffect(() => {
    resetModulesLoad();
  }, [location, resetModulesLoad]);

  return {
    isAllModulesLoaded: isLoaded,
    setModuleLoaded: setLoaded,
    loadedModules: () =>
      Object.entries(listeners).reduce((acc, [key, value]) => {
        if (value === 1) {
          acc.push(key);
        }
        return acc;
      }, []),
    isAnyLoaded: Object.values(listeners).some((value) => value === 1),
    isModuleLoaded: (key) => {
      return Object.keys(listeners).some(
        (k) => k === key && listeners[k] === 1,
      );
    },
  };
};
